export const BANK_OPEN_CONNECT = 'OPEN_CONNECT'
export const BANK_OPEN_FIX = 'OPEN_FIX'
export const BANK_OPEN_ALTERNATE = 'OPEN_ALTERNATE'
export const BANK_PLAID = 'PLAID'
export const BANK_ATRIUM = 'ATRIUM'
export const BANK_WIDGET_STATE_CLOSED = 'closed'
export const BANK_WIDGET_STATE_CONNECT = 'connect'
export const BANK_WIDGET_STATE_FIX = 'fix'
export const BANK_ACTION_CONNECT = 'connect'
export const BANK_ACTION_FIX = 'fix'

/* Underwriting methods */
export const UW_DO_NOT_CHANGE = 'DO_NOT_CHANGE'
export const UW_AUTO = 'AUTO'
export const UW_CASH_DEPOSIT = 'CASH_DEPOSIT'
export const UW_CASH_RICH = 'CASH_RICH'
export const UW_CASH_UNDERWRITING = 'CASH_UNDERWRITING'
export const UW_CC_MATCH = 'CC_MATCH'
export const UW_FS = 'FS'
export const UW_INDUSTRY_MODEL = 'INDUSTRY_MODEL'
export const UW_MGMT_CALL = 'MGMT_CALL'
export const UW_MKT_MIN = 'MKT_MIN'
export const UW_PREPAY = 'PREPAY'
export const UNDERWRITING_METHODS = [
  UW_DO_NOT_CHANGE,
  UW_AUTO,
  UW_CASH_DEPOSIT,
  UW_CASH_RICH,
  UW_CASH_UNDERWRITING,
  UW_CC_MATCH,
  UW_FS,
  UW_INDUSTRY_MODEL,
  UW_MGMT_CALL,
  UW_MKT_MIN,
  UW_PREPAY
]
